konnyScript(function($){
  /* 환경 체크 -- 모바일인지 */
  function Mobile(){
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  if (Mobile()){// 모바일일 경우
      $('.conBt').addClass('mo');
  }

  var swiper = new Swiper('#prd_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      scrollbar: {
          el:'#prd_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el:'#prd_swiper_slide1 .swiper-pagination',
      },
  });
  
  var swiper = new Swiper('#iv_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      scrollbar: {
          el:'#iv_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el:'#iv_swiper_slide1 .swiper-pagination',
      },
  });
});